var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48,
    fill: "white",
    stroke: "#B4AFAF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_1227)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 35.6841V69.8944C69 72.1621 67.1469 74 64.862 74H33.138C30.8522 74 29 72.1621 29 69.8944V26.1056C29 23.8379 30.8522 22 33.138 22H55.2065L69 35.6841Z",
    fill: "#CB0606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 34.9179V36.6209H57.7241C55.3894 36.6209 54.3126 34.7359 54.3126 32.4114V22H56.0204L69 34.9179Z",
    fill: "#FB8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6988 49.6632C59.3429 49.5462 59 49.4869 58.6694 49.4869C58.2939 49.4869 58.0359 49.5641 57.8947 49.7185C57.7543 49.8729 57.6841 50.1459 57.6841 50.5383V51.2882H59.2621V52.7946H57.6841V58.998H55.7723V52.7946H54.787V51.2882H55.7723V50.5383C55.7723 49.5828 56.0106 48.8922 56.4874 48.4656C56.9641 48.039 57.6808 47.8262 58.6392 47.8262C59.089 47.8262 59.5657 47.8871 60.0694 48.0098L59.6988 49.6632ZM51.6906 58.2481C51.3347 58.5471 50.9592 58.7852 50.5641 58.9615C50.169 59.1378 49.72 59.2255 49.2164 59.2255C48.2384 59.2255 47.4898 58.8754 46.9715 58.175C46.4523 57.4738 46.1935 56.4842 46.1935 55.2053C46.1935 53.8972 46.4784 52.8807 47.049 52.1552C47.6196 51.4304 48.4204 51.0672 49.4531 51.0672C49.8188 51.0672 50.1935 51.142 50.5788 51.2915C50.9641 51.441 51.2833 51.6311 51.5347 51.861V48.0537H53.4466V58.998H51.6906V58.2481ZM51.5347 53.4267C51.3323 53.2455 51.0817 53.0847 50.7829 52.9449C50.4841 52.806 50.1788 52.7361 49.8678 52.7361C49.3543 52.7361 48.9421 52.9555 48.631 53.3934C48.3192 53.8322 48.1641 54.4261 48.1641 55.176C48.1641 55.9162 48.2915 56.4964 48.5453 56.918C48.8 57.3397 49.1935 57.5502 49.7274 57.5502C50.0433 57.5502 50.3657 57.4779 50.6939 57.3332C51.0221 57.1886 51.3029 57.0107 51.5347 56.8002V53.4267ZM43.3633 58.7259C42.8939 59.059 42.3339 59.2255 41.6817 59.2255C40.8221 59.2255 40.089 58.959 39.4817 58.4244V61.9011H37.5698V51.2882H39.3331V52.0447C39.689 51.7408 40.0629 51.5019 40.4555 51.328C40.8482 51.1542 41.2988 51.0672 41.8074 51.0672C42.7902 51.0672 43.5388 51.4101 44.0523 52.0967C44.5657 52.7824 44.8229 53.7794 44.8229 55.0875C44.8229 55.9162 44.6972 56.6459 44.4449 57.278C44.1927 57.9101 43.8327 58.3927 43.3633 58.7259ZM42.4596 53.3642C42.1976 52.9449 41.8074 52.7361 41.289 52.7361C40.978 52.7361 40.658 52.8084 40.3298 52.9522C40.0008 53.0969 39.7184 53.2748 39.4817 53.4852V56.8587C39.6841 57.0407 39.9347 57.2008 40.2335 57.3405C40.5323 57.4803 40.8392 57.5502 41.1559 57.5502C41.6792 57.5502 42.0931 57.3284 42.3968 56.8847C42.7004 56.4411 42.8523 55.852 42.8523 55.1175C42.8523 54.3676 42.7208 53.7834 42.4596 53.3642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_1227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 52,
    fill: "white",
    transform: "translate(29 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.2d250b17ea695183990be68e8bdfd8fd.svg";
export { ForwardRef as ReactComponent };